export class AddnewGroup {
  name: string;
  description: string;
  class_id: string;
  students: string[] = [];
}